let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("18185")).then(() => parcelRequire('b8qXZ'));